export interface Edge<T> {
  node: T;
}
export interface Connection<T> {
  edges: Array<Edge<T>> | undefined;
}

export function mapEdgesToItems<T>(
  data: Connection<T> | undefined | null,
): T[] {
  return data?.edges?.map(({ node }) => node) || [];
}

type coordinatLatOrLng = { lat: number; lng: number };
export const getGeoDistance = (
  start: coordinatLatOrLng,
  end: coordinatLatOrLng,
) => {
  const deg2rad = (deg: number) => deg * (Math.PI / 180);
  const R = 6371;
  const dLat = deg2rad(end.lat - start.lat);
  const dLng = deg2rad(end.lng - start.lng);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(start.lat)) *
      Math.cos(deg2rad(end.lat)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let distance = R * c * 1000;
  distance = distance / 1000;
  return Math.round(distance * 100) / 100;
};
